import { Component, OnInit, Input, EventEmitter, ViewChild, TemplateRef, AfterContentChecked } from '@angular/core';
import { MyTask } from '../home.model';
import { TableData, TableOptions } from '../../shared/shared.model';
import { HomeService } from '../home.service';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { DISPLAY_DATE_FORMAT } from '../../app.constants';

@Component({
  selector: 'iaud-my-tasks',
  templateUrl: './my-tasks.component.html',
  styleUrls: ['./my-tasks.component.scss']
})
export class MyTasksComponent implements OnInit, AfterContentChecked {
  @ViewChild('workflowCell') workflowCell: TemplateRef<any>;
  @ViewChild('titleFieldCell') titleFieldCell: TemplateRef<any>;
  @ViewChild('idFieldCell') idFieldCell: TemplateRef<any>;
  @ViewChild('requestCell') requestCell: TemplateRef<any>;

  @Input()
  reload?: EventEmitter<boolean>;

  myTasksTableData: TableData<MyTask>

  myTasksOptions: TableOptions = {
    actionButtons: false,
    columns: [
      {
        title: 'Request ID',
        fieldName: 'capaId',
      },
      {
        title: 'Workflow',
        fieldName: 'findingStrId',
      },
      {
        title: 'Current Step',
        fieldName: 'currentStep',
      },
      {
        title: 'Status',
        fieldName: 'status',
      },
      {
        title: 'Assign Date',
        fieldName: 'assignDate',
        pipe: new DatePipe('en-US'),
        pipeParams: DISPLAY_DATE_FORMAT,
      },
      {
        title: 'Requester',
        fieldName: 'requester',
      },
      {
        title: 'Due Date',
        fieldName: 'dueDate',
        pipe: new DatePipe('en-US'),
        pipeParams: DISPLAY_DATE_FORMAT,
      },
    ],
    additionalInfo: [
      {
        title: 'Audit/SID Id',
        fieldName: 'auditStrId',
      },
      {
        title: 'Audit/SID Title',
        fieldName: 'auditTitle',
      },
      {
        title: 'Finding Id',
        fieldName: 'findingStrId',
      },
      {
        title: 'Finding Title',
        fieldName: 'findingTitle',
      },
    ],
  };
  hasInitialMyTasks: boolean;


  constructor(private homeService: HomeService) { }

  ngOnInit(): void {
    this.reloadMyTasks(undefined, undefined)
      .subscribe((table: TableData<MyTask>) => {
        this.myTasksTableData = table;
        if (this.hasInitialMyTasks == null) {
          this.hasInitialMyTasks = table.items.length > 0;
        }
      });
  }
  ngAfterContentChecked(): void {
    this.myTasksOptions.columns[0].customTemplate = this.requestCell;
    this.myTasksOptions.columns[1].customTemplate = this.workflowCell;
    this.myTasksOptions.additionalInfo[0].customTemplate = this.idFieldCell;
    this.myTasksOptions.additionalInfo[1].customTemplate = this.titleFieldCell;
  }

  reloadMyTasks(page: number, pageSize: number): Observable<TableData<MyTask>> {
    return this.homeService.getMyTasks(page, pageSize);
  }

}
